import {Atom, useAtomValue} from 'jotai';
import React, {useState} from 'react';
import {Navigate} from 'react-router';
import {logoutNow} from '~/entities/user';
import {resetKYCStatus} from '~/entities/user/api/updateKYCStatus';
import {useHttpClient} from '~/library/network-facade';
import {RootLayout, RsnButton} from '~/library/ui-kit';
import {appSessionStorage} from '~/shared/persistence';
import {useAppDispatch} from '~/shared/store';
import styles from '../Signup.module.scss';

export default function Stuck({
    userInfo$,
}: {
    userInfo$: Atom<{data?: {status: string}; refetch: () => Promise<unknown>}>;
}) {
    const [inProgress, setInProgress] = useState(false);
    const {data: userInfoQueryData, refetch} = useAtomValue(userInfo$);
    const userStatus = userInfoQueryData?.status ?? appSessionStorage.authStatus.get();
    const http = useHttpClient();
    const dispatch = useAppDispatch();

    const handleProceed = async () => {
        setInProgress(true);
        resetKYCStatus(http)
            .then(async response => {
                if (response.status === 401) {
                    dispatch(logoutNow);
                    return;
                }

                appSessionStorage.authStatus.set(response.json.status);
                await refetch();
            })
            .finally(() => setInProgress(false));
    };

    if (userStatus !== 'stuck') {
        return <Navigate replace to='/signup/kyc' />;
    }

    return (
        <RootLayout title='Registration'>
            <div className='flex flex-1 flex-col px-4 pb-4 pt-6'>
                <div className={styles.page_notification}>
                    <div className={styles.page_notification_header}>OOPS!</div>
                    <div className={styles.page_notification_text}>
                        More than 7 days have passed <br /> since you applied for the account. <br /> Please start the
                        verification process <br /> to start using RAISON.
                    </div>
                </div>
                <footer className='mt-auto'>
                    <RsnButton disabled={inProgress} onClick={handleProceed}>
                        Proceed
                    </RsnButton>
                </footer>
            </div>
        </RootLayout>
    );
}
